import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
export function SaleNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(showTimer);
  }, []);
  return <AnimatePresence data-id="element-182">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 40,
      x: -10
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 40
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-xs bg-white rounded-2xl shadow-2xl border border-gray-100 p-4 flex items-start gap-3" role="status" aria-live="polite" data-id="element-183">
          <div className="bg-success/10 text-success p-2 rounded-full shrink-0" data-id="element-184">
            <ShoppingBag className="w-5 h-5" data-id="element-185" />
          </div>
          <div className="flex-1 pr-4" data-id="element-186">
            <p className="text-sm font-bold text-navy leading-tight" data-id="element-187">
              Martín R. de Buenos Aires
            </p>
            <p className="text-xs text-gray-500 mt-0.5" data-id="element-188">
              compró el ProfePack hace 7 minutos
            </p>
          </div>
          <button onClick={() => setVisible(false)} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-gray-300 hover:text-gray-500 transition-colors" data-id="element-189">
            <X className="w-4 h-4" data-id="element-190" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}